import React from 'react';
import {Col, Row} from "react-bootstrap";
import {TextField} from "@material-ui/core";

const Insurance4 = () => {
    return (
        <div className="personal_affairs_container">
            <div className="info_header">
                <h3>Insurance</h3>
            </div>
            <div className="content mt-3 mb-5">
                {["INSURANCE TYPE:","INSURANCE TYPE:"].map((title,index)=> (
                    <div className="mb-4" key={index}>
                        <Row className="mx-0">
                            <Col md="4 pl-0">
                                <h5>{title}</h5>
                            </Col>
                            <Col md="8">
                            <TextField
                                    variant="filled"
                                    fullWidth={true}
                                    size="small"
                                />
                            </Col>
                        </Row>
                        {[
                            "Company:", "Address:", "Policy #:",
                            "Amount:","Date of Policy:",
                            "Beneficiary:","Location: "
                        ].map((title) => (
                            <Row className="mx-0" key={title}>
                                <Col md="3 pl-0">
                                    {title}
                                </Col>
                                <Col md="9">
                                    <TextField
                                        variant="filled"
                                        fullWidth={true}
                                        size="small"
                                    />
                                </Col>
                            </Row>
                        ))}
                        <Row className="mx-0">
                            <Col md="3 pl-0" className="d-flex align-items-center">
                                Agent:
                            </Col>
                            <Col md="4 pr-0">
                                <TextField
                                    variant="filled"
                                    fullWidth={true}
                                    size="small"
                                />
                            </Col>
                            <Col md="2" className="d-flex align-items-center justify-content-center bg-white">
                                Phone #
                            </Col>
                            <Col md="3 pl-0">
                                <TextField
                                    variant="filled"
                                    fullWidth={true}
                                    size="small"
                                />
                            </Col>
                        </Row>
                        <Row className="my-2 mx-0">
                            <Col md="12 pl-0">
                                Notes:
                            </Col>
                            <Col md="12 pl-0">
                                <TextField
                                    variant="filled"
                                    fullWidth={true}
                                    size="small"
                                    multiline={true}
                                    rows={3}
                                />
                            </Col>
                        </Row>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Insurance4;